import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export type TArticle = Omit<TArticleResponseResult, 'html_url'>;

type TArticleResponseResult = {
  id: number;
  html_url: string;
  url: string;
  title: string;
};

type TArticlesResponseResult = {
  results: TArticleResponseResult[];
};

// Documentation page: https://developer.zendesk.com/api-reference/help_center/help-center-api/search/#search-articles
export const zendeskApi = createApi({
  reducerPath: 'zendeskApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://trevor9030.zendesk.com/api/v2/',
  }),
  endpoints: (builder) => ({
    getArticlesBySearch: builder.query<TArticle[], { search: string }>({
      query: ({ search }) => `help_center/articles/search?query=${search}`,
      transformResponse: (response: TArticlesResponseResult) =>
        response.results.map((result) => {
          return { ...result, url: result.html_url };
        }),
    }),
  }),
});

export const { useGetArticlesBySearchQuery } = zendeskApi;
